import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5a90ec03&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=5a90ec03&lang=css"
import style1 from "./Home.vue?vue&type=style&index=1&id=5a90ec03&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90ec03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a90ec03')) {
      api.createRecord('5a90ec03', component.options)
    } else {
      api.reload('5a90ec03', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=5a90ec03&scoped=true", function () {
      api.rerender('5a90ec03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Home.vue"
export default component.exports